import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import EmailPreviewButton from "./emailPreviewButton";
import EmailPreviewModal from "./emailPreviewModal";
import { wrapWithSpans } from "../../util/templateWrap";
// Private static variables
const spanClasses = ["text-danger", "font-weight-bold"];
export default class EmailPreview extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            modalIsOpen: false,
        };
        this.loadSubject = () => this.props
            .getSubject()
            .then((subject) => wrapWithSpans(subject, spanClasses));
        this.loadBody = () => this.props.getBody().then((body) => wrapWithSpans(body, spanClasses));
    }
    render() {
        return (_jsxs("div", { children: [_jsx(EmailPreviewButton, { onClick: () => this.setState({ modalIsOpen: true }) }), _jsx(EmailPreviewModal, { isOpen: this.state.modalIsOpen, modalId: this.props.modalId, loadSubject: this.loadSubject, loadBody: this.loadBody, onCloseModal: () => this.setState({ modalIsOpen: false }) })] }));
    }
}
